// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__T9MEc","rightAdornment":"Header_rightAdornment__3dlvz"};